import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ordersBasePath, orderDetailPath, listeordersPath } from './constants';
import { OrderRoot, OrderDetail, ListeOrders } from './views';

export const OrderRouter: RouteObject = {
    path: ordersBasePath,
    element: <OrderRoot />,
    children: [
        {
            path: listeordersPath,
            element: <ListeOrders />,
        },
        {
            path: orderDetailPath,
            element: <OrderDetail />,
        },
    ],
};
